import * as type from './types';
import exceljs from "exceljs";

export const messegeCloseTime = {
    "Error":5000,
    "Info":3000,
}

export const messegeColor ={
    "Error":"red",
    "Warnig":"orange darken-2",
    "Sccess":"cyan lighten-4",
}

export const notConnectError = {
    "httpStatus":1,
    "code":1
} as type.errorDetail
export const unknowError = {
    "httpStatus":0,
    "code":0
} as type.errorDetail
export const invalidSession = (vueRef:any) => {
    vueRef.$emit("parentCall","invalidSession");
}

export const LoadingOverlay = (vueRef:any,sw:boolean,appRoot=false) => {
    let messege = "";
    if(sw){
        messege = "loadingON";
    }else{
        messege = "loadingOFF";
    }
    if(appRoot){
        vueRef.appCall(messege);
    }else{
        vueRef.$emit("parentCall",messege);
    }
}

export const SuccessMessege = (vueRef:any,messege:string,appRoot=false) => {
    vueRef.$store.commit("setSysMessege",{
        "color":messegeColor.Sccess,
        "text":messege,
        "timeout":messegeCloseTime.Info,
    });
    if(appRoot){
        vueRef.appCall("systemMessege");
    }else{
        vueRef.$emit("parentCall","systemMessege");
    }
}
export const WaringMessege = (vueRef:any,messege:string,timeout?:number|null,appRoot=false) => {
    vueRef.$store.commit("setSysMessege",{
        "color":messegeColor.Warnig,
        "text":messege,
        "timeout":typeof timeout === "number"?timeout:messegeCloseTime.Info,
    });
    if(appRoot){
        vueRef.appCall("systemMessege");
    }else{
        vueRef.$emit("parentCall","systemMessege");
    }
}
export const ApiErrorMessege = (vueRef:any,response:type.errorDetail,appRoot=false) => {
    const errorInfo = {
        code:0,
        messege:"",
    }
    if(!response){
        errorInfo.code = 500000;
        errorInfo.messege = vueRef.text.errorMessege[0];
    }else{
        errorInfo.code = response.code;
        errorInfo.messege = typeof vueRef.text.errorMessege[errorInfo.code] === "string"?vueRef.text.errorMessege[errorInfo.code]:vueRef.text.errorMessege[0]
    }
    vueRef.$store.commit("setSysMessege",{
        "color":messegeColor.Error,
        "text":`Error[${errorInfo.code}]:<br>${errorInfo.messege}`,
        "timeout":messegeCloseTime.Error,
    });
    if(appRoot){
        vueRef.appCall("systemMessege");
    }else{
        vueRef.$emit("parentCall","systemMessege");
    }
}
export const SnackbarMessege = (vueRef:any,messege:string,color:string,appRoot=false,timeout?:number) => {
    vueRef.$store.commit("setSysMessege",{
        "color":color,
        "text":messege,
        "timeout":typeof timeout === "number"?timeout:messegeCloseTime.Info,
    });
    if(appRoot){
        vueRef.appCall("systemMessegeSnack");
    }else{
        vueRef.$emit("parentCall","systemMessegeSnack");
    }
}

export const formatDate = (date:Date,format:string) => {
    format = format.replace(/yyyy/g, date.getFullYear().toString());
    format = format.replace(/mm/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/mn/g, ((date.getMonth() + 1).toString()));
    format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/MM/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/SS/g, ('0' + date.getSeconds()).slice(-2));
    format = format.replace(/sss/g, ('00' + date.getMilliseconds()).slice(-3));
    return format;
}

export const contentDispositionFilenameReg = new RegExp(`filename=[\\"\\'](.+)[\\"\\']`);

const subArea = {
    "01":100,
    "02":200,
    "03":210,
    "04":220,
    "05":230,
    "06":240,//山形県
    "07":250,//福島県
    "08":300,//茨城県
    "09":310,//栃木県
    "10":320,//群馬県
    "11":330,//埼玉県
    "12":340,//千葉県
    "13":350,//東京都
    "14":360,//神奈川県
    "15":370,//新潟県
    "16":380,//富山県
    "17":390,//石川県
    "18":400,//福井県
    "19":410,//山梨県
    "20":420,//長野県
    "21":430,//岐阜県
    "22":440,//静岡県
    "23":450,//愛知県
    "24":460,//三重県
    "25":500,//滋賀県
    "26":510,//京都府
    "27":520,//大阪府
    "28":530,//兵庫県
    "29":540,//奈良県
    "30":550,//和歌山県
    "31":560,//鳥取県
    "32":570,//島根県
    "33":580,//岡山県
    "34":590,//広島県
    "35":700,//山口県
    "36":600,//徳島県
    "37":610,//香川県
    "38":620,//愛媛県
    "39":630,//高知県
    "40":710,//福岡県
    "41":720,//佐賀県
    "42":730,//長崎県
    "43":740,//熊本県
    "44":750,//大分県
    "45":760,//宮崎県
    "46":770,//鹿児島県
    "47":800,//沖縄県
} as {[code:string]:number};

export const areaCodeSort = (a:{value:string,text:string},b:{value:string,text:string}) => {
    const aValueNum = a.value.length>2?parseInt(a.value,10):subArea[a.value];
    const bValueNum = b.value.length>2?parseInt(b.value,10):subArea[b.value];
    if (aValueNum === bValueNum){
        if(a.value.length < b.value.length){
            return -1;
        }else{
            return 1;
        }
    }else if(aValueNum < bValueNum){
        return -1;
    }else{
        return 1;
    }
}
const quakeLeveReg = new RegExp(`([0-9])([\\-+]*)`);
const quakeLeveStr2Number = (str:string) => {
    const qMatc = str.match(quakeLeveReg);
    if(qMatc && qMatc[2]){
        return parseInt(qMatc[1],10)+(qMatc[2]==="-"?0.1:qMatc[2]==="+"?0.5:0.9)
    }else if(qMatc){
        return parseInt(qMatc[1],10)
    }else{
        return null;
    }
}
export const quakeLevelSort = (a:{value:string,text:string},b:{value:string,text:string}) => {

    const aValueNum = quakeLeveStr2Number(a.value)
    const bValueNum = quakeLeveStr2Number(b.value)
    if(!aValueNum || !bValueNum){
        return 0;
    }
    if(aValueNum <= bValueNum){
        return -1
    }else{
        return 1;
    }
}

export const strReplacePercentObject = (str:string,replaceObj:{[key:string]:string}) => {
    const split = str.split(new RegExp(`(%[^\x20]+\x20|%\x20)`));
    let replaceStr = "";
    split.forEach(v=>{
        const percent = v.match(new RegExp(`^%(.+)\x20$`));
        if(percent){
            if(replaceObj[percent[1]]){
                replaceStr += replaceObj[percent[1]];
            }
        }else if(v==="%\x20"){
            replaceStr += "%";
        }else{
            replaceStr += v;
        }
    });
    return replaceStr;
}
const formulaReg = /^=(.+)/;
export const exceljsUtils = {
    setRow : (sheet:exceljs.Worksheet,origin:{row:number,column:number},cells:Array<string|number|null>) => {
        const originCell = sheet.getCell(origin.row,origin.column);
        let cellColumn = originCell.col as unknown as number;
        const cellRow = originCell.row as unknown as number;
        if(originCell){
            for(const cellData of cells){
                if(typeof cellData === "string"){
                    const formulaMatch = cellData.match(formulaReg);
                    if(formulaMatch){
                        const formulaString = formulaMatch[1];
                        //@ts-ignore
                        sheet.getCell(cellRow,cellColumn).value = {"formula":formulaString};
                        //sheet.cell(cellRow,cellColumn).value(0);
                    }else{
                        sheet.getCell(cellRow,cellColumn).value = cellData;
                    }
                }else{
                    sheet.getCell(cellRow,cellColumn).value = cellData;
                }
                cellColumn++;
            }
        }
    },
    setRowStyle : (sheet:exceljs.Worksheet,origin:{row:number,column:number},styles:Array<exceljs.Style>) => {
        const originCell = sheet.getCell(origin.row,origin.column);
        let cellColumn = originCell.col as unknown as number;
        const cellRow = originCell.row as unknown as number;
        if(originCell){
            for(const styleData of styles){
                if(styleData.alignment){
                    sheet.getCell(cellRow,cellColumn).alignment = styleData.alignment;
                }
                if(styleData.border){
                    sheet.getCell(cellRow,cellColumn).border = styleData.border;
                }
                if(styleData.fill){
                    sheet.getCell(cellRow,cellColumn).fill = styleData.fill;
                }
                if(styleData.font){
                    sheet.getCell(cellRow,cellColumn).font = styleData.font;
                }
                if(styleData.numFmt){
                    sheet.getCell(cellRow,cellColumn).numFmt = styleData.numFmt;
                }
                if(styleData.border){
                    sheet.getCell(cellRow,cellColumn).border = styleData.border;
                }
                cellColumn++;
            }
        }
    },
    setColumnWidth: (sheet:exceljs.Worksheet,origin:{row:number,column:number},widths:Array<number>) => {
        const originCell = sheet.getCell(origin.row,origin.column);
        let cellColumn = originCell.col as unknown as number;
        const cellRow = originCell.row as unknown as number;
        if(originCell){
            for(const width of widths){
                sheet.getColumn(cellColumn).width = width;
                cellColumn++;
            }
        }
    },
}

export const reportColumnCounter = (reportData:Array<Array<string>>,columnNo:number):{labels:Array<string>,data:Array<number>} =>{
    const returnData = {
        "labels":[] as Array<string>,
        "data":[] as Array<number>,
    }
    for(const data of reportData){
        const tgtStr = data[columnNo];
        if(tgtStr){
            const labelIndex = returnData.labels.indexOf(tgtStr);
            if(labelIndex < 0){
                returnData.labels.push(tgtStr);
                returnData.data.push(1);
            }else{
                returnData.data[labelIndex]++;
            }
        }
    }
    return returnData;
}

export const deleteUndefinedPropties = (obj:{[key:string]:any}) => {
    for (const [k,v] of Object.entries(obj)){
        if(typeof v === "undefined"){
            delete obj[k];
        }
    }
    return obj;
}
export const spacerChr = ["#","$","%","&","@",":",";","/","-","_"];
export const passwordAddDic = ["ogi","ogihara","yajima","ota","gunma"];